// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jRoM","newExpiryDate":"styles_newExpiryDate__OAe6p","footer":"styles_footer__2wQTl"};